import React from "react";
import { FormControlLabel } from "@mui/material";

import { FormControl, Radio, RadioGroup } from "@mui/material";
import Label from "./LabelF";
import { VALOR_TODAS_SELECT } from "../../../helper/opcionesFiltros";

const RadioF = (props) => {
  const {
    filtrosAAplicar,
    aplicarFiltroValorActivo,
    radio_opciones,
    id_a,
    grid_span,
  } = props;

  const handleRadio = (e) => {
    aplicarFiltroValorActivo(e.target.value)
  };

  const styles = {
    gridColumn: grid_span,
    borderBottom: props.error[id_a] ? "red solid 1px" : "unset",
  };

  return (
    <FormControl style={styles} error={props.error[id_a]}>
      <Label
        label={props.label}
        opcionales_null={props.opcionales_null}
        permite_null={props.permite_null}
        style={{ marginBottom: "0px" }}
      />
      <div className="filtro_grid_radio_button">
        <RadioGroup
          value={filtrosAAplicar[id_a] ?? VALOR_TODAS_SELECT}
          onChange={(e) => handleRadio(e)}
          row
        >
          {radio_opciones.map((item) => {
            return (
              <FormControlLabel
                key={item.label + "_" + item.value}
                value={item.value}
                control={<Radio size="small" />}
                label={item.label}
                className="radio_button"
              />
            );
          })}

          {props.select_todas !== "n" ? (
            <FormControlLabel
              key="Todas"
              value={VALOR_TODAS_SELECT}
              control={<Radio size="small" />}
              label={"Todas"}
              className="radio_button"
            />
          ) : (
            <></>
          )}
        </RadioGroup>
      </div>
    </FormControl>
  );
};

export default RadioF;
